import { PocButton } from 'commons/components/components-wrapper/poc-button.component';
import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { BulkActionsComponent } from 'commons/components';
import { useTranslation } from 'core/i18n/i18n';
import { useEapSettingsList } from 'modules/settings/contexts/eap-settings/hooks/use-eap-settings-list.hook';
import { useDeleteEapSetting } from '../settings-devices-eap-settings-list/hooks/use-delete-eap-setting/use-delete-eap-setting.hook';
import { BulkDeleteEapSettingsComponent } from './bulk-delete-eap-settings.component';
import { BulkEditEapSettingsComponent } from './bulk-edit-eap-settings.component';

export const SettingsDevicesEapSettingsBulkActionsContainer: React.FC = () => {
    const { t } = useTranslation();
    const { selectedRows, clearSelectedRows, onDeleted } = useEapSettingsList();
    const { openDeleteConfirmation } = useDeleteEapSetting({
        onDeleted,
    });

    return (
        selectedRows.length > 0 && (
            <BulkActionsComponent
                options={[
                    <PocTypography key="bulk_actions_selected" element="span" variant="subtitle1">
                        {t('settings.devices.eap-settings.eap-config-list.bulk.action.selected', {
                            amount: selectedRows.length,
                        })}
                    </PocTypography>,
                    <PocButton
                        key="bulk_actions_deselect"
                        variant="tertiary"
                        size="medium"
                        onClick={() => clearSelectedRows()}
                    >
                        {t('settings.devices.eap-settings.eap-config-list.bulk.action.clear-all')}
                    </PocButton>,
                ]}
            >
                {selectedRows.length === 1 && <BulkEditEapSettingsComponent eapSettingId={selectedRows[0].id} />}
                <BulkDeleteEapSettingsComponent onClick={() => openDeleteConfirmation(selectedRows)} />
            </BulkActionsComponent>
        )
    );
};
